import React from "react";
import { Box, Button, alpha, useTheme } from "@mui/material";
import { Backspace } from "@mui/icons-material";

/**
 * Reusable Number Pad Component
 * Used in PaymentSplitDialog and CashPaymentDialog for consistent design
 *
 * @param {function} onNumberClick - Handler for number button clicks (receives button value)
 * @param {boolean} disabled - Whether the number pad is disabled
 */
const NumberPad = ({ onNumberClick, disabled = false }) => {
  const theme = useTheme();

  const numPadButtons = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "0",
    "⌫",
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 1.5,
      }}
    >
      {numPadButtons.map((btn) => (
        <Button
          key={btn}
          variant="outlined"
          onClick={() => onNumberClick(btn)}
          disabled={disabled}
          sx={{
            height: 100,
            fontSize: "1.8rem",
            fontWeight: 700,
            borderRadius: 2,
            borderWidth: 2,
            borderColor: alpha(theme.palette.grey[300], 0.5),
            color: theme.palette.text.primary,
            bgcolor: "white",
            boxShadow: `0 2px 8px ${alpha(theme.palette.grey[400], 0.15)}`,
            "&:hover": {
              borderWidth: 2,
              borderColor: theme.palette.primary.main,
              bgcolor: alpha(theme.palette.primary.main, 0.05),
              transform: "translateY(-2px)",
              boxShadow: `0 4px 16px ${alpha(theme.palette.primary.main, 0.2)}`,
            },
            "&:disabled": {
              bgcolor: alpha(theme.palette.grey[200], 0.5),
            },
            transition: "all 0.2s ease",
          }}
        >
          {btn === "⌫" ? <Backspace /> : btn}
        </Button>
      ))}
    </Box>
  );
};

export default NumberPad;
